<template>
    <div class="footer">
        <img src="../../assets/images/logo/consultied_logo_new.svg">
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {mapActions} from 'vuex'
    export default {
        name: "footer",
        computed: {
            ...mapGetters(["getLocale"]),
        },
        methods:{
         
            changeLocale(locale){
                this.$store.dispatch('CHANGE_LOCALE_REQUEST',locale);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/main";

    .footer {
        display: flex;
        flex-direction: row;
        justify-content: center;
        height: 60px!important;
        align-items: center;
        background-color: rgb(0, 0, 0);
    }
</style>